import { FormStep, IFormModel } from ".";
import {
  IAboutYouFormModel,
  IAboutYouYPFormModel,
  CurrentMemberBlockPropsType,
} from "./AboutYouFormModel";
import {
  EligibilitySteps,
  ICourseFormModel,
  ICreditFormModel,
  JoiningType,
} from "./EligibilityFormModel";
import { billingAddressInitialValues } from "../components/BillingAddressFormBlock";

export const currentMemberBlockProps: CurrentMemberBlockPropsType = {
  currentMember: null,
  currentName: "",
  currentPerformerType: null,
  currentEmail: "",
};

const commonAboutYouFormValues: IAboutYouYPFormModel = {
  photoUploadForm: {
    photo: [],
    photographerName: "",
  },
  aboutYouInformationForm: {
    // only for YP
    currentMember: null,
    currentName: "",
    currentPerformerType: null,
    currentEmail: "",
    publishAge: "no",
    playingAgeFrom: null,
    playingAgeTo: null,
    gender: null,
    customOrNonBinaryGender: null,
    furtherInformation: "",
    showGenderOnProfile: null,
    deafOrDisabled: "no",
    ...billingAddressInitialValues,
  },
};

const mainPerformerAboutYouSpecificFields: IAboutYouFormModel = {
  photoUploadForm: commonAboutYouFormValues.photoUploadForm,
  aboutYouInformationForm: {
    ...commonAboutYouFormValues.aboutYouInformationForm,
    mobileNumber: "+44",
    landlineNumber: "+44",
    dateOfBirth: null,
    membershipOptions: [],
    agents: [],
    ...billingAddressInitialValues,
  },
};

export const INITIAL_FORM_VALUES: IFormModel = {
  [FormStep.Eligibility]: {
    [EligibilitySteps.JoiningAs]: {
      joiningAs: null,
    },
    [EligibilitySteps.AdditionalInformation]: {
      [JoiningType.Experienced]: [],
      [JoiningType.Training]: [],
      [JoiningType.Recommendation]: {
        refereeName: "",
        refereeMembership: null,
        s3ObjectKey: "",
      },
    },
  },
  [FormStep.AboutYou]: mainPerformerAboutYouSpecificFields,
  [FormStep.AboutYouMPCurrentMember]: currentMemberBlockProps,
  [FormStep.AboutYouYP]: commonAboutYouFormValues,
  [FormStep.Review]: {
    preferences: [],
    emailPreferences: [],
    thirdParties: "",
  },
};

export const INITIAL_COURSE_FORM_VALUES: ICourseFormModel = {
  schoolName: "",
  courseName: "",
  dateFrom: null,
  dateTo: null,
  qualificationLevel: null,
  courseUrl: "",
  s3ObjectKey: "",
  courseType: null,
};

export const INITIAL_CREDIT_FORM_VALUES: ICreditFormModel = {
  productionName: "",
  type: null,
  roleName: "",
  company: "",
  director: "",
  creditLink: "",
  dateFrom: null,
  dateTo: null,
  s3ObjectKey: "",
  equityRole: null,
};
